var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-bread"},[_c('span',[_vm._v("您所在的位置：")]),_c('a',{on:{"click":_vm.toPage}},[_vm._v("首页")]),_c('span',[_vm._v(">")]),_c('a',{staticClass:"navigation-cur has_theme color_1577FE"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }